import { render } from "./QuoteForm.vue?vue&type=template&id=45062ae4&scoped=true"
import script from "./QuoteForm.vue?vue&type=script&lang=js"
export * from "./QuoteForm.vue?vue&type=script&lang=js"

import "./QuoteForm.vue?vue&type=style&index=0&id=45062ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45062ae4"]])

export default __exports__